// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.radiobtn-container[data-v-79697090] {\n  width: 100%;\n  margin-bottom: -20px;\n}", ""]);
// Exports
module.exports = exports;
